import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

import MentionNodeView from '../components/MentionNodeView';
import { MENTION_NODE_NAME } from '../const';

function plugins({ createReactNodeView }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          [MENTION_NODE_NAME]: (node, view, getPos, decorations) => {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              inline: true,
              component: MentionNodeView,
            });
          },
        },
      },
    }),
  ];
}

export default plugins;
